// src/stone/icons/Ecommerce2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Ecommerce2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M2.75 28.375H16v2H2.75zM2.75 6.5h27v2h-27z" }),
      /* @__PURE__ */ jsx("path", { d: "M6.25 2.25c-.823 0-1.5.677-1.5 1.5v32.5c0 .823.677 1.5 1.5 1.5h20c.823 0 1.5-.677 1.5-1.5v-9.125h2v9.125c0 1.927-1.573 3.5-3.5 3.5h-20a3.507 3.507 0 0 1-3.5-3.5V3.75c0-1.927 1.572-3.5 3.5-3.5h20c1.927 0 3.5 1.573 3.5 3.5v12.875h-2V3.75c0-.823-.677-1.5-1.5-1.5z" }),
      /* @__PURE__ */ jsx("path", { d: "M22.187 27.875a1.187 1.187 0 1 0 0 2.375 1.187 1.187 0 0 0 0-2.375M19 29.063a3.187 3.187 0 1 1 6.375 0 3.187 3.187 0 0 1-6.375 0M35.312 27.875a1.187 1.187 0 1 0 0 2.375 1.187 1.187 0 0 0 0-2.375m-3.187 1.188a3.187 3.187 0 1 1 6.375 0 3.187 3.187 0 0 1-6.375 0M16.875 11.5h4.589l.551 3.125h14.79l-1.583 9.5H21.66L19.786 13.5h-2.911zm5.493 5.125.97 5.5h10.19l.916-5.5z" })
    ]
  }
);
var Ecommerce2X_default = Ecommerce2X;

export {
  Ecommerce2X,
  Ecommerce2X_default
};
